import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=f77b374a&scoped=true"
import script from "./talk.vue?vue&type=script&lang=js"
export * from "./talk.vue?vue&type=script&lang=js"
import style0 from "./talk.vue?vue&type=style&index=0&id=f77b374a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77b374a",
  null
  
)

export default component.exports